<template>
  <div>
    <legend class="h4">
      Fyll ut kontaktinfo
    </legend>
    <p>
      Etter innsendt skjema vil du få et digitalt tilbud på e-post med en
      gyldighet på 30 dager.<br />
      Tilbudet er <b>ikke bindende</b> og innsending av skjema er
      <b>helt uforpliktende</b>.
    </p>
    <div class="row">
      <div class="col-l-8 col-s-10">
        <div type="text" class="form__field-group form__field--text">
          <label for="form-fullName">{{ nameLabel }}</label>
          <input
            type="text"
            name="fullName"
            id="form-fullName"
            placeholder="Fornavn og etternavn"
            v-model="fullName"
            :data-valid="fullNameValid"
            autocomplete="name"
          />
        </div>
        <div type="text" class="form__field-group form__field--text">
          <label for="form-phoneNumber">Telefon</label>
          <input
            type="text"
            name="phoneNumber"
            id="form-phoneNumber"
            :placeholder="phonePlaceholder"
            v-model="phoneNumber"
            :data-valid="phoneValid"
            autocomplete="tel-national"
          />
          <em class="form__field--error-message" v-if="phoneNumberError">{{
            phoneNumberError
          }}</em>
        </div>
        <div type="text" class="form__field-group form__field--text">
          <label for="form-email">E-post</label>
          <input
            type="email"
            name="email"
            id="form-email"
            :placeholder="emailPlaceholder"
            v-model="email"
            :data-valid="emailValid"
            autocomplete="email"
          />
          <em class="form__field--error-message" v-if="emailError">{{
            emailError
          }}</em>
        </div>
        <div type="text" class="form__field-group form__field--text">
          <label for="form-address">Postadresse</label>
          <input
            type="text"
            name="address"
            id="form-address"
            placeholder="Faktura-adresse"
            v-model="address"
            :data-valid="addressValid"
            autocomplete="address-line1"
          />
          <em class="form__field--error-message" v-if="addressError">{{
            addressError
          }}</em>
        </div>
        <div class="row">
          <div class="col-s-5">
            <div type="text" class="form__field-group form__field--text">
              <label for="form-postalcode">Postnummer</label>
              <input
                type="number"
                name="postalcode"
                id="form-postalcode"
                placeholder="0000"
                v-model="postalCode"
                :data-valid="postalCodeValid"
                autocomplete="postal-code"
              />
              <em class="form__field--error-message" v-if="postalCodeError">{{
                postalCodeError
              }}</em>
            </div>
          </div>
          <div class="col-s-7">
            <div type="text" class="form__field-group form__field--text">
              <label for="form-address">Poststed</label>
              <input
                type="text"
                name="poststed"
                id="form-postalarea"
                placeholder="Poststed"
                v-model="postalArea"
                :data-valid="postalAreaValid"
                autocomplete="address-level2"
              />
              <em class="form__field--error-message" v-if="postalAreaError">{{
                postalAreaError
              }}</em>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-s-12">
            <div
              type="textarea"
              class="form__field-group form__field--textarea"
            >
              <label for="form-comment">Kommentar</label>
              <textarea
                type="text"
                name="comment"
                id="form-comment"
                placeholder="Noe mer vi bør vite? Spesielle hensyn eller ønsker?"
                v-model="comment"
                data-valid="true"
                maxlength="255"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row" v-if="discountPeriodActive">
          <div class="col-s-12">
            <div type="text" class="form__field-group form__field--text">
              <label for="form-discount-code">Rabattkode</label>
              <input
                type="text"
                name="discount-code"
                id="form-discount-code"
                placeholder="Rabattkode"
                v-model="discountCodeUserInput"
                :data-valid="discountCodeMatch"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';

export default {
  name: 'CustomerInformation',
  data() {
    return {
      customerInformation: {},
      discountCode: store.state.discountCode,
    };
  },
  computed: {
    fullNameValid() {
      return this.fullName.length > 3;
    },
    nameLabel() {
      switch (this.selectedCustomerType) {
        case 'privat':
          return 'Fullt navn';
        default:
          return 'Kontaktperson';
      }
    },
    phoneValid() {
      return this.phoneNumber.length > 7;
    },

    phoneNumberError() {
      var re = /^\d{8}$/;
      if (this.phoneNumber && !this.phoneValid) {
        return 'Vennligst skriv inn et gyldig telefonnummer';
      }
      if (this.phoneNumber && !re.test(this.phoneNumber)) {
        return 'Telefonnummer skal inneholde 8 tegn og kun tall.';
      }
      return false;
    },
    phonePlaceholder() {
      switch (this.selectedCustomerType) {
        case 'privat':
          return 'Helst privatnummer';
        default:
          return 'Telefon kontaktperson';
      }
    },
    emailValid() {
      var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      return re.test(String(this.email).toLowerCase());
    },
    emailError() {
      if (this.email && !this.emailValid) {
        return 'Vennligst skriv inn en gyldig e-post';
      }
      return false;
    },
    emailPlaceholder() {
      switch (this.selectedCustomerType) {
        case 'privat':
          return 'Helst privat e-post';
        default:
          return 'E-post kontaktperson';
      }
    },
    addressValid() {
      return this.address != '';
    },
    addressError() {
      if (this.address && !this.addressValid) {
        return 'Vennligst skriv inn adresse';
      }
      return false;
    },
    postalCodeValid() {
      return this.postalCode.length == 4;
    },
    postalCodeError() {
      if (this.postalCode && !this.postalCodeValid) {
        return 'Vennligst skriv inn et gyldig postnummer';
      }
      return false;
    },
    postalAreaValid() {
      return this.postalArea != '';
    },
    postalAreaError() {
      if (this.postalArea && !this.postalAreaValid) {
        return 'Vennligst skriv inn poststed';
      }
      return false;
    },
    contactInfoValid() {
      return (
        this.fullNameValid &&
        this.emailValid &&
        this.phoneValid &&
        this.addressValid &&
        this.postalCodeValid &&
        this.postalAreaValid
      );
    },

    fullName: {
      get() {
        return store.state.CustomerInformation.fullName;
      },
      set(value) {
        store.state.CustomerInformation.fullName = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },

    phoneNumber: {
      get() {
        return store.state.CustomerInformation.phoneNumber;
      },
      set(value) {
        store.state.CustomerInformation.phoneNumber = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    email: {
      get() {
        return store.state.CustomerInformation.email;
      },
      set(value) {
        store.state.CustomerInformation.email = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    address: {
      get() {
        return store.state.CustomerInformation.address;
      },
      set(value) {
        store.state.CustomerInformation.address = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    postalCode: {
      get() {
        return store.state.CustomerInformation.postalCode;
      },
      set(value) {
        store.state.CustomerInformation.postalCode = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    postalArea: {
      get() {
        return store.state.CustomerInformation.postalArea;
      },
      set(value) {
        store.state.CustomerInformation.postalArea = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    comment: {
      get() {
        return store.state.CustomerInformation.comment;
      },
      set(value) {
        store.state.CustomerInformation.comment = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    discountCodeUserInput: {
      get() {
        return store.state.discountCodeUserInput;
      },
      set(value) {
        store.commit('setDiscountCodeUserInput', value);
      },
    },
    discountCodeMatch() {
      return (
        this.discountCodeUserInput.trim().toLowerCase() === this.discountCode
      );
    },
    discountPeriodActive() {
      let today = new Date();
      let last_day = new Date('2019/05/01');

      return today < last_day;
    },
    selectedCustomerType() {
      return store.state.CustomerType;
    },
  },
  watch: {
    contactInfoValid(val) {
      store.commit('setCustomerInformationValid', val);
    },
    discountCodeMatch(val) {
      if (val) {
        store.commit('setDiscount', 3000);
      } else {
        store.commit('setDiscount', 0);
      }
    },
  },
  created() {
    this.customerInformation = store.state.CustomerInformation;
  },
  methods: {},
};
</script>
